import { FC, useState } from 'react';

import { isBrandFilter } from '../../../../../../utils';
import BrandFilterItem from './BrandFilterItem';
import { BrandFiltersSectionProps } from './types';

const BrandFiltersSection: FC<BrandFiltersSectionProps> = ({
    currentFilterData,
    fieldPrefix,
    formKey,
    onFilterChange,
}) => {
    const [showAllBrands, setShowAllBrands] = useState(false);
    const brandFilters = currentFilterData.filter(isBrandFilter);

    if (brandFilters.length === 0) {
        return null;
    }

    return (
        <>
            {brandFilters.map(filterField => (
                <BrandFilterItem
                    key={filterField.code}
                    filterField={filterField}
                    fieldPrefix={fieldPrefix}
                    formKey={formKey}
                    showAllBrands={showAllBrands}
                    onToggleShowAll={() => setShowAllBrands(prev => !prev)}
                    onFilterChange={onFilterChange}
                />
            ))}
        </>
    );
};

export default BrandFiltersSection;
